import get from 'lodash/get';
import { FieldErrors } from 'react-hook-form';

// Separa el name en partes y busca el error en el objeto de errores
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getError = (errors: FieldErrors<any>, name: string) => {
  return get(errors, name);
};
